import { PlayerWithRisk } from '../../pages/dashboard/dashboard.type';

export enum PlayerRisk {
  LOW = 'low',
  INTERVENTION_OFFERED = 'intervention_offered',
  INTERVENTION_REQUIRED = 'intervention_required',
  EXCLUDED = 'excluded',
}

export type PlayerIconProps = {
  player: PlayerWithRisk;
  onHoverChange?: (hovered: boolean) => void;
  onClick: () => void;
  noAnimation?: boolean;
};
